/**
 * File that can be loaded in each page as a mixin, handles generic stuff for validation functions
 */
export const validationMixin = {
    methods: {
        validateEmail(email) {
            let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        validateNumber(number) {
            let re = /^\d+$/;
            return re.test(number);
        },
        validatePhoneNumber(phoneNumber) {
            let re = /^(\+[0-9]{2}|\+[0-9]{2}\(0\)|\(\+[0-9]{2}\)\(0\)|00[0-9]{2}|0)([0-9]{9}|6[\-\s]{1}[0-9]{8}|[0-9]{2}[\-\s]{1}[0-9]{7}|[0-9]{3}[\-\s]{1}[0-9]{6})$/;
            return re.test(phoneNumber);
        },
        validateStringLength(string, maxLength, minLength = 0) {
            if(minLength !== 0) {
                return (this.validateStringMinLength(string, minLength) && this.validateStringMaxLength(string, maxLength))
            }

            return this.validateStringMaxLength(string, maxLength);
        },
        validateStringMaxLength(string, length) {
            return (string.length <= length);
        },
        validateStringMinLength(string, length) {
            return (string.length >= length);
        },
        validateAddress(address) {
            let re = /^(?=.*\d)[A-Za-zÀ-ÖØ-öø-ÿ0-9 .-]+$/;
            return re.test(address);
        },
        validatePostalcode(postalCode) {
            let re = /^[1-9][0-9]{3} ?(?!sa|sd|ss|SA|SD|SS)[A-Za-z]{2}$/;
            return re.test(postalCode);
        },

        /**
         * The regular expression used below was found on the following website
         * https://stackoverflow.com/questions/3809401/what-is-a-good-regular-expression-to-match-a-url
         * (www\.)? was not added because not necessary in our case. 
         * 
         * @param {*} url. The url to be validated
         * @returns a boolean. The result is true when this is a valid url
         */
        validateUrl(url) {
            let re = /^https?:\/\/[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;
            return re.test(url);
        },

        /**
         * The regular expression used below was found on the following website
         * https://github.com/ajv-validator/ajv-formats/blob/master/src/formats.ts
         * 
         * @param {*} ref. The uri reference to be validated
         * @returns  a boolean. The result is true when this is a valid url
         */
        validateUriReference(ref) {
            let re = /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
            return re.test(ref);
        }
    }
}
